import { StatusCodes } from "http-status-codes";
import {
  IDeleteCommonHealthCareResponse,
  IDeleteHealthCareRequiredDocumentResponse,
} from "../../interfaces/IHealthCare";
import Axios from "../../utils/axiosInterceptor";
import { HEALTH_CARE_APIS } from "../../utils/constants";

export const deleteHealthCareDoctor = async (
  healthCareId: number,
  id: number
): Promise<IDeleteCommonHealthCareResponse> => {
  try {
    const response = await Axios.delete(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${healthCareId}/health_care_doctors/${id}`
    );

    if (response.status === StatusCodes.OK) {
      return {
        id: id,
        status: response.status,
        message: "health care doctor deleted successfully",
      };
    } else {
      return {
        errorMessage: "Cannot delete health care doctor",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error deleting health care doctor:", error);
    throw new Error("Cannot delete health care doctor");
  }
};

export const deleteManageUser = async (
  healthCareId: number,
  id: number
): Promise<IDeleteCommonHealthCareResponse> => {
  try {
    const response = await Axios.delete(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${healthCareId}/health_care_management_user/${id}`
    );

    if (response.status === StatusCodes.OK) {
      return {
        id: id,
        status: response.status,
        message: "Manage user deleted successfully",
      };
    } else {
      return {
        errorMessage: "Cannot delete health care manage user",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error deleting health care manage user:", error);
    throw new Error("Cannot delete health care manage user");
  }
};

export const deleteSchemeSpecificLoginDetail = async (
  healthCareId: number,
  id: number
): Promise<IDeleteCommonHealthCareResponse> => {
  try {
    const response = await Axios.delete(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${healthCareId}/health_care_mis_credentials_scheme_specific/${id}`
    );

    if (response.status === StatusCodes.OK) {
      return {
        id: id,
        status: response.status,
        message: "Scheme specific login detail deleted successfully",
      };
    } else {
      return {
        errorMessage: "Cannot delete scheme specific login detail",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error deleting scheme specific login detail:", error);
    throw new Error("Cannot delete scheme specific login detail");
  }
};

export const deleteBillingUrlForm = async (
  healthCareId: number,
  id: number
): Promise<IDeleteCommonHealthCareResponse> => {
  try {
    const response = await Axios.delete(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${healthCareId}/health_care_billing_credentials/${id}`
    );

    if (response.status === StatusCodes.OK) {
      return {
        id: id,
        status: response.status,
        message: "Billing url form deleted successfully",
      };
    } else {
      return {
        errorMessage: "Cannot delete billing url form",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error deleting billing url form:", error);
    throw new Error("Cannot delete billing url form");
  }
};

export const deleteHealthCareRequiredDocument = async (
  healthCareId: number,
  id: number
): Promise<IDeleteHealthCareRequiredDocumentResponse> => {
  try {
    const response = await Axios.delete(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${healthCareId}/health_care_required_documents/${id}`
    );

    if (response.status === StatusCodes.CREATED) {
      return {
        id: id,
        status: response.status,
        message: "Health care required document deleted successfully",
      };
    } else {
      return {
        errorMessage: "Cannot delete health care required document",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error deleting health care required document:", error);
    throw new Error("Cannot delete health care required document");
  }
};
